/* ss-video-circles.js — video tròn TỰ CHẠY trong ô (đúng bản gốc) + player fullscreen.

   Chiến lược nạp: chỉ gắn src khi ô lọt vào khung nhìn, pause khi cuộn khỏi.
   4 video autoplay cùng lúc mà nạp hết ngay từ đầu sẽ giết LCP trên mobile —
   cách này nhìn y hệt bản gốc nhưng nhẹ hơn nhiều. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function playSafe(v) {
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* trình duyệt chặn: giữ nguyên poster */ });
  }

  function initRow(row) {
    if (row._ssInit) return;
    row._ssInit = true;

    var items = Array.prototype.slice.call(row.querySelectorAll('.ss-vc__item'));
    var dlg = document.querySelector('[data-ss-video-player]');
    if (!items.length) return;

    /* ---------- 1. Tự chạy trong ô ---------- */
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var btn = e.target;
          var v = btn.querySelector('.ss-vc__video');
          if (!v) return;
          if (e.isIntersecting) {
            if (!v.src && btn.dataset.src) v.src = btn.dataset.src;
            playSafe(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '150px 0px', threshold: 0.25 });
      items.forEach(function (b) { io.observe(b); });
    } else {
      // reduced-motion hoặc trình duyệt cũ: giữ poster tĩnh, không nạp video
      items.forEach(function (b) {
        var v = b.querySelector('.ss-vc__video');
        if (v) v.removeAttribute('autoplay');
      });
    }

    /* ---------- 2. Bấm -> player fullscreen ---------- */
    if (!dlg) return;
    var big = dlg.querySelector('.ss-vcp__video');
    var label = dlg.querySelector('.ss-vcp__label');
    var cur = 0;

    function open(i) {
      cur = (i + items.length) % items.length;
      var el = items[cur];
      big.src = el.dataset.src || '';
      big.poster = el.dataset.poster || '';
      var l = el.querySelector('.ss-vc__label');
      label.textContent = l ? l.textContent.trim() : '';
      if (!dlg.open) {
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      }
      playSafe(big);
    }

    function close() {
      big.pause();
      big.removeAttribute('src');
      big.load();
      if (dlg.open && typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function () { open(i); });
    });

    var prev = dlg.querySelector('[data-prev]');
    var next = dlg.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { open(cur - 1); });
    if (next) next.addEventListener('click', function () { open(cur + 1); });
    var x = dlg.querySelector('[data-close]');
    if (x) x.addEventListener('click', close);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); open(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); open(cur + 1); }
    });
    big.addEventListener('ended', function () {
      if (cur < items.length - 1) open(cur + 1); else close();
    });

    var x0 = null;
    dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) open(dx < 0 ? cur + 1 : cur - 1);
      x0 = null;
    }, { passive: true });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ss-video-circles]').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
